import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUploadFile } from "./FileUploadApi";
import swal from 'sweetalert';
export interface DocumentMState {
  uploadFile: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DocumentMState = {
    uploadFile: [],
  status: "idle",
};

export const GetUploadFile = createAsyncThunk(
  "UploadFile/fetchUploadFile",
  async (data:any) => {
    const response = await fetchUploadFile(data);
    return response;
  }
);

export const UploadFileSlice = createSlice({
  name: "UploadFile",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUploadFile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUploadFile.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUploadFile.fulfilled, (state, action) => {
        state.status = "idle";
        state.uploadFile = action.payload;
        swal("Record updated success!",  "success");
      });
  },
});

export const {} = UploadFileSlice.actions;

export const selectUploadFile = (state: RootState) => {
  return state.UploadFile.uploadFile;
};

export default UploadFileSlice.reducer;
